<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, RouterLink } from 'vue-router'
import { useConfigStore } from '@/stores/config'
import { allNavItems } from '@/lib/nav-items'

const route = useRoute()
const configStore = useConfigStore()

const navItems = computed(() =>
  allNavItems
    .filter((item) => item.featureKey !== 'settings')
    .filter((item) => configStore.isFeatureEnabled(item.featureKey)),
)

function isActive(to: string) {
  if (to === '/') return route.path === '/'
  return route.path.startsWith(to)
}
</script>

<template>
  <nav
    class="fixed bottom-0 left-0 right-0 z-40 h-14 border-t bg-background pb-[env(safe-area-inset-bottom)]"
    aria-label="Mobile navigation"
  >
    <div class="flex h-full items-center justify-around">
      <RouterLink
        v-for="item in navItems"
        :key="item.to"
        :to="item.to"
        class="flex flex-col items-center justify-center gap-0.5 flex-1 h-full text-xs"
        :class="isActive(item.to) ? 'text-primary' : 'text-muted-foreground'"
      >
        <component :is="item.icon" class="size-5" />
        <span>{{ item.label }}</span>
      </RouterLink>
    </div>
  </nav>
</template>
